/**
 * Utility functions for filtering and processing text content
 */

/**
 * Removes just-in-time UI tags from text content for display in transcript
 * Filters out tags like <question>...</question> and any other UI-related tags
 * while preserving the actual text content
 */
export const removeUITags = (text: string): string => {
  if (!text) return text;

  // Define UI tags that should be filtered out from transcript display
  const uiTagPatterns = [
    // Question tags: <question>...</question>
    /<question>.*?<\/question>/gs
    // Add other UI tag patterns here as needed
    // Example: /<discrepancy>.*?<\/discrepancy>/gs,
  ];

  let filteredText = text;

  // Remove each UI tag pattern
  uiTagPatterns.forEach((pattern) => {
    filteredText = filteredText.replace(pattern, '').trim();
  });

  // Clean up extra whitespace and line breaks that might be left
  filteredText = filteredText
    .replace(/\n\s*\n/g, '\n') // Replace multiple line breaks with single
    .replace(/^\s+|\s+$/g, '') // Trim leading/trailing whitespace
    .trim();

  return filteredText;
};

/**
 * Checks if text contains any UI tags
 */
export const hasUITags = (text: string): boolean => {
  if (!text) return false;

  const uiTagPatterns = [/<question>.*?<\/question>/gs];

  return uiTagPatterns.some((pattern) => pattern.test(text));
};
